import { Icon } from "@nabble/ui";
import { Link } from "react-router-dom";
import { ACCOUNT_SECTIONS, accountPath, type AccountSectionId } from "./accountSections";

/** The left list of My account, marking the view on screen. */
export function AccountSectionsNav({ current }: { current: AccountSectionId }): React.JSX.Element {
  return (
    <nav className="nb-settings-nav" aria-label="My account sections">
      {ACCOUNT_SECTIONS.map((s) => (
        <Link key={s.id} to={accountPath(s.id)} aria-current={s.id === current ? "true" : undefined}>
          <Icon name={s.icon} />
          {s.label}
        </Link>
      ))}
    </nav>
  );
}
